const initHeaderDrawerPromosSwiper = () => {
  if (typeof window.Swiper !== 'function') return;

  const root = document.querySelector('.menu-drawer__accordion-promos');
  if (!root) return;

  const swiperEl = root.querySelector('.menu-drawer__accordion-swiper');
  if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

  const prevEl = root.querySelector('.menu-drawer__accordion-promos-btn--prev');
  const nextEl = root.querySelector('.menu-drawer__accordion-promos-btn--next');

  new Swiper(swiperEl, {
    slidesPerView: 'auto',
    spaceBetween: 10,
    centeredSlides: false,
    freeMode: true,
    loop: false,
    navigation:
      prevEl && nextEl
        ? {
            nextEl,
            prevEl
          }
        : false,
    on: {
      init() {
        swiperEl.classList.add('swiper-initialized');
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initHeaderDrawerPromosSwiper();
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.menu-drawer__accordion-promos')) {
    initHeaderDrawerPromosSwiper();
  }
});

